// src/pages/products/LinerOpener.jsx
import React from "react";
import SEO from "../../components/SEO";
import ProductSection from "../../components/ProductCard";
import img1 from '../../images/fibc-liner-opener-machine/liner-opener-bfm1200-3.webp';
import img2 from '../../images/fibc-liner-opener-machine/liner-opener-bfm1200-2.webp';
import img3 from '../../images/fibc-liner-opener-machine/liner-opener-bfm1200-1.webp';

const LinerOpenerPage = () => {
  const canonical = "https://akmake.in/products/liner-opener-machine"; // update to real URL
  const seoProduct = {
    name: "Liner Opener Machine",
    images: [
      "https://www.akmake.in/images/lineropener4.jpg",
      "https://www.akmake.in/images/lineropener3.jpg",
      "https://www.akmake.in/images/lineropener2.jpg",
    ],
    description: "Semi-Automatic Liner Opener — 3 HP motor, 2 bags/min, compressed air operation, emergency stop.",
    sku: "LO-3HP-2025",
    brand: "AKMAKE Engineering",
    url: canonical,
  };

  return (
    <>
      <SEO
        title={`${seoProduct.name} | AKMAKE Engineering`}
        description={seoProduct.description}
        canonical={canonical}
        images={seoProduct.images}
        product={seoProduct}
        twitterHandle="@AKMAKE" // optional
      />

      <ProductSection
        title="Liner Opener Machine"
        subheader="Semi-Automatic system for efficient and safe liner opening"
        images={[img1, img2, img3]}
        specs={[
          ["Machine Type", "Semi-Automatic"],
          ["Power Supply", "415V, 50Hz (Three Phase)"],
          ["Motor Power", "3 HP"],
          ["Production Capacity", "2 Bags Per Minute"],
          ["Liner Size", "30 cm (Minimum)"],
          ["Air Consumption", "6 Bar"],
          ["Compressed Air Pressure", "6-8 Bar"],
          ["Control System", "Manual Operating System"],
          ["Safety Features", "Emergency Stop"],
        ]}
        features={[
          "Optimized performance with minimal operator intervention",
          "Efficient and continuous operation with 3 HP motor",
          "Handles 2 bags per minute – ideal for moderate-scale operations",
        ]}
        applications={`Our Semi-Automatic Liner Opener Machine is designed for efficient and safe opening of liners in industrial packaging processes.`}
        contactCta={`Contact us today to learn how this machine can improve your liner-opening workflow and operator safety.`}
      />
    </>
  );
};

export default LinerOpenerPage;
